import { DateTime } from 'luxon'

const normalizeApiDateTime = (value: string) => {
  if (value.includes('T')) return value
  if (value.includes(' ')) return value.replace(' ', 'T')
  return value
}

export const parseApiDateTime = (value?: string | null) => {
  if (value === null || value === undefined || value.length === 0) return null

  const normalized = normalizeApiDateTime(value)

  const asIso = DateTime.fromISO(normalized, { setZone: true })
  if (asIso.isValid) return asIso

  const asSql = DateTime.fromSQL(value, { setZone: true })
  if (asSql.isValid) return asSql

  return null
}
